import React from "react";
import { Colors } from "../../../Constants/colors";
import { FontFamily } from "../../../Constants/Enums/FontFamily.enums";
import {
  ALIGN_ITEMS,
  DISPLAY,
  FLEX_DIRECTION,
  FONT_SIZE,
  JUSTIFY_CONTENT,
  POSITION,
  SPACING,
} from "../../../Constants/Enums/styles.enum";
import { BtnSize, BtnType, Button } from "../../Button";
import { useMobile } from "../../../hooks/deviceHooks/useDevice.hooks";
import { CheckCircleIcon } from "../../Icon/CheckCircleIcon";
import { DocumentIcon } from "../../Icon/DocumentIcon";
import { DownloadIcon } from "../../Icon/DownloadIcon";

interface IProps {
  reportLink: string | null;
  studentName: string;
}

export const StudentResultReport = ({ reportLink, studentName }: IProps) => {
  const isMobile = useMobile();

  if (!reportLink) return <></>;

  const handleDownload = () => {
    window.open(reportLink, "_blank");
  };

  return (
    <div
      style={{
        display: DISPLAY.FLEX,
        width: "100%",
        padding: "0",
      }}
    >
      <div
        style={{
          display: DISPLAY.FLEX,
          flexDirection: isMobile ? FLEX_DIRECTION.COLUMN : FLEX_DIRECTION.ROW,
          alignItems: isMobile ? ALIGN_ITEMS.START : ALIGN_ITEMS.CENTER,
          justifyContent: JUSTIFY_CONTENT.SPACE_BETWEEN,
          backgroundColor: Colors.White,
          border: `2px solid ${Colors.LightAshRose}`,
          borderRadius: isMobile ? "8px" : "12px",
          padding: isMobile ? "12px 16px" : "16px 24px",
          width: "100%",
          position: POSITION.RELATIVE,
          overflow: "hidden",
          gap: isMobile ? SPACING.S12 : SPACING.S20,
        }}
      >
        {/* Decorative background elements */}
        {!isMobile && (
          <>
            <div
              style={{
                position: "absolute",
                top: "-30px",
                right: "-30px",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                backgroundColor: "#FFE5D9",
                opacity: 0.3,
                zIndex: 0,
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                left: "-20px",
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                backgroundColor: "#E3F2FD",
                opacity: 0.4,
                zIndex: 0,
              }}
            />
          </>
        )}

        {/* Left side - Icon and Content */}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            display: DISPLAY.FLEX,
            flexDirection: "row",
            alignItems: ALIGN_ITEMS.CENTER,
            gap: isMobile ? "12px" : "20px",
            flex: 1,
            width: isMobile ? "100%" : "auto",
          }}
        >
          <div
            style={{
              display: DISPLAY.FLEX,
              alignItems: ALIGN_ITEMS.CENTER,
              justifyContent: JUSTIFY_CONTENT.CENTER,
              flexShrink: 0,
            }}
          >
            <DocumentIcon size={isMobile ? 35 : 50} />
          </div>

          {/* Text Content */}
          <div
            style={{
              display: DISPLAY.FLEX,
              flexDirection: "column",
              gap: isMobile ? "4px" : "6px",
              flex: 1,
            }}
          >
            {/* Success indicator */}
            <div
              style={{
                display: DISPLAY.FLEX,
                alignItems: ALIGN_ITEMS.CENTER,
              }}
            >
              <CheckCircleIcon size={isMobile ? 14 : 18} />
              <span
                style={{
                  marginLeft: "6px",
                  fontFamily: FontFamily.ROBOTO_REGULAR,
                  fontSize: FONT_SIZE.F12,
                  color: Colors.Success,
                }}
              >
                Result Generated Successfully
              </span>
            </div>

            {/* Main heading */}
            <h2
              style={{
                fontFamily: FontFamily.ROBOTO_BOLD,
                fontSize: isMobile ? "14px" : "18px",
                color: Colors.Black,
                margin: 0,
                lineHeight: "1.2",
              }}
            >
              {studentName}'s result report is ready
            </h2>

            {/* Description text */}
            {!isMobile && (
              <p
                style={{
                  fontFamily: FontFamily.ROBOTO_REGULAR,
                  fontSize: "12px",
                  color: "#666666",
                  margin: 0,
                  lineHeight: "1.4",
                }}
              >
                The generated result report is now available for download.
              </p>
            )}
          </div>
        </div>

        {/* Right side - Download Button */}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            display: DISPLAY.FLEX,
            alignItems: ALIGN_ITEMS.CENTER,
            flexShrink: 0,
            width: isMobile ? "100%" : "auto",
          }}
        >
          <Button
            text={"Download"}
            onClick={handleDownload}
            btnSize={BtnSize.sm}
            additionalComponent={<DownloadIcon />}
            btnType={BtnType.primary}
            btnStyle={{
              padding: isMobile ? "8px 16px" : "10px 20px",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: 500,
              width: isMobile ? "100%" : "auto",
            }}
          />
        </div>
      </div>
    </div>
  );
};
